import { useTranslation } from "react-i18next";
import { FileCode2 } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

const Stat = ({ label, value, tone = "text-foreground" }) => (
  <div className="rounded-2xl bg-background p-3 shadow-neu-sm">
    <p className="text-[10px] font-bold text-muted-foreground">{label}</p>
    <p className={`mt-1 font-mono text-lg font-black ${tone}`}>{value}</p>
  </div>
);

export const CodeHealthCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;
  const ok = data.compliance_percent >= 95;

  return (
    <NeuCard
      data-testid="system-code-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <FileCode2 className="h-4 w-4 text-primary" /> {t("system.code")}
      </p>

      <div className="mt-4 grid grid-cols-2 gap-2.5 sm:grid-cols-3">
        <Stat label={t("system.files")} value={data.files} />
        <Stat label={t("system.lines")} value={data.lines.toLocaleString("en-GB")} />
        <Stat label={t("system.endpoints")} value={data.endpoints} />
        <Stat label={t("system.backendFiles")} value={data.parts.backend.files} />
        <Stat label={t("system.frontendFiles")} value={data.parts.frontend.files} />
        <Stat
          label={t("system.compliance", { max: data.max_lines_rule })}
          value={`${data.compliance_percent}%`}
          tone={ok ? "text-primary" : "text-amber-500"}
        />
      </div>

      <p className="mt-4 text-xs font-bold text-muted-foreground">
        {t("system.oversized", { count: data.oversized_count, max: data.max_lines_rule })}
      </p>
      {data.violations?.length ? (
        <p
          className="mt-2 rounded-2xl bg-destructive/15 px-3 py-2 text-xs font-black text-destructive"
          data-testid="line-guard-badge"
        >
          {t("system.lineGuardBreach", { count: data.violations.length, file: data.violations[0].file })}
        </p>
      ) : (
        <p className="mt-2 text-[11px] font-bold text-primary" data-testid="line-guard-ok">
          {t("system.lineGuardOk", { count: data.baseline_count })}
        </p>
      )}
      <ul className="mt-2 grid gap-1.5 font-mono text-[11px]" data-testid="system-oversized">
        {[...data.parts.backend.oversized, ...data.parts.frontend.oversized]
          .sort((a, b) => b.lines - a.lines)
          .slice(0, 8)
          .map((f) => (
            <li key={f.file} className="flex items-center justify-between gap-3 rounded-xl bg-background px-3 py-2 shadow-neu-sm">
              <span className="truncate text-muted-foreground">{f.file}</span>
              <span className="font-black text-amber-500">{f.lines}</span>
            </li>
          ))}
      </ul>
    </NeuCard>
  );
};
